import React from "react"
import {UserList} from "components/backoffice/User/List/UserList"
import {useQuery} from "@apollo/client"

import userListQuery from "graphql/User/query/userList"

import './style.scss'
import {URL_BACKOFFICE_USER_ADD} from "static/constant/url"
import {Link} from "react-router-dom"
import {BackofficePage, BackofficePanel, BackofficeEmptyState} from "components/backoffice/Layout/BackofficePage"

export const UserListRoute = () => {

  const {data} = useQuery(userListQuery)
  const userList = data?.userList

  return <BackofficePage
    className="user-list-route-container"
    eyebrow="Administration"
    title="Utilisateurs"
    description="Gérez les comptes autorisés à accéder à Zipflix."
    icon="fa-users"
    actions={<Link className="bo-primary-action" to={URL_BACKOFFICE_USER_ADD}><span className="fas fa-user-plus"></span>Ajouter</Link>}
  >
    <BackofficePanel title="Comptes actifs" description={`${userList?.length || 0} utilisateur${userList?.length > 1 ? "s" : ""}`} icon="fa-user-shield">
      {userList?.length ? <UserList userList={userList} /> : <BackofficeEmptyState title="Aucun utilisateur" description="Ajoutez le premier compte autorisé." icon="fa-user" />}
    </BackofficePanel>
  </BackofficePage>
}
